import { useState } from "react";
import KitLogo from "../../assets/images/adminPanel/logo.png";

const Navigation = () => {
  const [mobileMenu, setMobileMenu] = useState(false);
  const openMobileMenu = () => {
    setMobileMenu(!mobileMenu);
  };
  return (
    <div className="w-full border bg-white border-b-lightGreenKite flex px-4 justify-between gap-x-8 sticky top-0 z-20">
      <div
        className={`py-2 flex md:hidden items-center`}
        onClick={openMobileMenu}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
      </div>
      <div className="py-2 flex items-center">
        <a href="">
          <img src={KitLogo} />
        </a>
      </div>
      <ul
        className={`${
          mobileMenu
            ? "flex flex-col justify-start items-start right-0"
            : "-right-[60%]"
        } fixed md:flex md:relative top-[57px] md:top-[unset] md:right-[0] z-20 h-screen md:h-auto w-3/5 md:w-full bg-white md:items-center md:gap-8 py-2 transition-[right] duration-300`}
      >
        <li className="hover:text-lightGreenKite border-b-2 md:border-0 w-full md:w-auto">
          <a
            href="https://kite.ir/tours/%D8%AA%D9%88%D8%B1-%D8%B7%D8%A8%DB%8C%D8%B9%D8%AA-%DA%AF%D8%B1%D8%AF%DB%8C"
            target="_blank"
          >
            تور طبیعت‌گردی
          </a>
        </li>
        <li className="hover:text-lightGreenKite border-b-2 md:border-0 w-full md:w-auto">
          <a
            className="px-4 md:px-2 py-3"
            href="https://kite.ir/tours/%D8%AA%D9%88%D8%B1-%D8%AF%D8%A7%D8%AE%D9%84%DB%8C"
            target="_blank"
          >
            تور داخلی
          </a>
        </li>
        <li className="hover:text-lightGreenKite border-b-2 md:border-0 w-full md:w-auto">
          <a
            className="px-4 md:px-2 py-3"
            href="https://kite.ir/tours/%D8%AA%D9%88%D8%B1-%D8%AE%D8%A7%D8%B1%D8%AC%DB%8C"
            target="_blank"
          >
            تور خارجی
          </a>
        </li>
        <li className="hover:text-lightGreenKite border-b-2 md:border-0 w-full md:w-auto">
          <a
            className="px-4 md:px-2 py-3"
            href="https://kite.ir/flight"
            target="_blank"
          >
            پرواز
          </a>
        </li>
        <li className="hover:text-lightGreenKite border-b-2 md:border-0 w-full md:w-auto">
          <a
            className="px-4 md:px-2 py-3"
            href="https://kite.ir/hotel"
            target="_blank"
          >
            هتل
          </a>
        </li>
        <li className="hover:text-lightGreenKite border-b-2 md:border-0 w-full md:w-auto">
          <a
            className="px-4 md:px-2 py-3"
            href="https://kite.ir/visa"
            target="_blank"
          >
            ویزا
          </a>
        </li>
        <li className="hover:text-lightGreenKite border-b-2 md:border-0 w-full md:w-auto">
          <a
            className="px-4 md:px-2 py-3"
            href="https://kite.ir/blog"
            target="_blank"
          >
            وبلاگ
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Navigation;
